/**
 * @generated SignedSource<<d7b0b60badfb1b50360d776629675750>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCoreBuyerIncentives_viewer$data = {
  readonly isCountryInEu: boolean | null;
  readonly " $fragmentType": "useCoreBuyerIncentives_viewer";
};
export type useCoreBuyerIncentives_viewer$key = {
  readonly " $data"?: useCoreBuyerIncentives_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCoreBuyerIncentives_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCoreBuyerIncentives_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "country",
          "variableName": "userCountryCode"
        }
      ],
      "kind": "ScalarField",
      "name": "isCountryInEu",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8d905d2f4738bfb7a1a35eab73a34657";

export default node;
